import axiosInstance from "../api/axiosInstance";
import { INVOICES } from "../constants/API_URLs";

export const updateInvoice = (id: any, data: any): Promise<any> => {
  return axiosInstance.patch(`${INVOICES}/${id}`, data);
};
